export const buildNumber = '9827';
